import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  gap: var(--general-spacer-02, 8px);
  align-items: flex-start;
  flex: 1 0 0;
  min-width: 260px;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--general-spacer-02, 8px);
  align-items: flex-start;
  flex: 1 0 0;
  min-width: 0;
`;

export const SubheaderWrapper = styled.div`
  width: 100%;
  padding-block-end: var(--general-spacer-01, 4px);
`;

export const ListItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--general-spacer-02, 8px);
  align-items: flex-start;
  width: 100%;
`;

export const LinkWrapper = styled.div`
  margin-block-start: var(--general-spacer-01, 4px);
`;
